/**
 * Single production origin for canonicals, OG URLs, and JSON-LD @id fields.
 */
export const SITE_ORIGIN = "https://organisatieopstellingen.com";

export const SITE_NAME = "Organisatieopstellingen";

export const SITE_BRAND_LINE = "door Marthe van der Molen";

export const LEERGANG_SEO_TITLE =
  "Leergang systemisch leiderschap | Duiken in de Onderstroom";

export const LEERGANG_SHORT_LABEL = "Leergang systemisch leiderschap";

export const LOGO_URL = `${SITE_ORIGIN}/organisatieopstellingen-logo.png`;

export const DEFAULT_OG_IMAGE = `${SITE_ORIGIN}/OG-image.jpg`;

export const LOCALE_OG = "nl_NL";

export const CONTACT = {
  email: "marthe@systemique.nl",
  phone: "+31-6-12991453",
} as const;

export const ADDRESS = {
  locality: "Castricum",
  region: "Noord-Holland",
  country: "NL",
} as const;

/** Gerelateerd particulier merk; zelfde aanbieder, andere site-intent. */
export const RELATED_BRAND_URL = "https://www.systemique.nl";

export const SOCIAL_SAME_AS = [
  `${SITE_ORIGIN}/`,
  `${SITE_ORIGIN}/over`,
  "https://www.linkedin.com/in/marthe-van-der-molen",
  "https://www.instagram.com/systemique.nl",
  RELATED_BRAND_URL,
] as const;

export const FOUNDER_SAME_AS = [
  "https://www.linkedin.com/in/marthe-van-der-molen",
  `${SITE_ORIGIN}/over`,
  RELATED_BRAND_URL,
] as const;
